import React from "react";
import {FourPointStar, CrookedStar} from "../../../assets";

const BonusProduct1 = () => {
  const bonusItems = [
    {
      icon: "📚",
      title: "E-book 4 IELTS Master",
      description: "Panduan lengkap strategi 4 skill IELTS",
    },
    {
      icon: "🎤",
      title: "Grup Speaking Eksklusif 1 Bulan",
      description: "Latihan speaking bareng sesama peserta + feedback",
    },
    {
      icon: "🎓",
      title: "Scholarship Preparation Course",
      description: "Essay, motivation letter, strategi interview",
    },
  ];

  return (
    <section className="overflow-x-clip st-bonus-section py-10 sm:py-12 lg:py-14" id="bonus-section">
      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative z-20 mx-auto flex flex-col items-center text-center">
      <h2 className="st-font-display st-bonus-title text-[48px] leading-[0.95] sm:text-[60px] lg:text-[72px]">
        <span className="font-bold">Bonus</span>{" "}
        <span className="italic">Ini Cuma Buat </span>
        <span className="font-bold">5</span>
      </h2>

      <p className="st-font-display st-bonus-title mt-4 text-[36px] leading-[0.95] sm:text-[48px] lg:text-[60px]">
        <span className="font-bold"> Orang Pertama!</span>
      </p>

      <div className="mt-4 text-[18px] font-medium st-bonus-subtitle sm:text-[20px] lg:text-[22px]">
        Jangan sampai kelewatan 😔
      </div>
        <div className="mt-10 grid w-full max-w-3xl gap-5 sm:gap-6 lg:gap-7">
          {bonusItems.map((item, index) => (
          <div
            key={index}
            className="st-bonus-card flex items-start gap-4"
          >
            <span className="text-3xl sm:text-4xl lg:text-5xl flex-shrink-0">
            {item.icon}
            </span>
            <div className="text-left">
            <h3 className="st-font-body text-[16px] font-bold text-[--st-color-bonus-card-text] sm:text-[18px] lg:text-[20px]">
              {item.title}
            </h3>
            <p className="st-font-body mt-2 text-[14px] text-[--st-color-bonus-card-text] leading-[1.5] sm:text-[16px] lg:text-[18px]">
              {item.description}
            </p>
            </div>
          </div>
          ))}
        <img
          src={FourPointStar}
          alt=""
          className="pointer-events-none absolute rotate-[35deg] left-[-88px] top-[58%] z-10 hidden w-[145px] md:block lg:left-[-3rem] lg:w-[14rem]"
          loading="lazy"
        />
        <img
          src={CrookedStar}
          alt=""
          className="pointer-events-none absolute rotate-[-35deg] right-[-8rem] top-[14%] z-10 hidden w-[220px] md:block lg:right-[-20px] lg:w-[16rem]"
          loading="lazy"
        />
        </div>
        </div>
      </div>
    </section>
  );
};

export default BonusProduct1;
